import { softwareTimelineEmbedEntrypoint } from '@jira/spa-apps__software-harmonised-timeline/src/softwareTimelineEmbedEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicSoftwareTimelineCustomEmbedRoute } from '@jira/router-routes__software-classic-timeline-routes/src/classicSoftwareTimelineCustomEmbedRoute.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import type { Route } from '@atlassian/react-resource-router';

const classicSoftwareTimelineCustomEmbedPageEntrypoint = createChromelessEntryPoint({
	main: softwareTimelineEmbedEntrypoint,
});

export const classicSoftwareTimelineCustomEmbedRouteEntry: Route = createEntry(
	classicSoftwareTimelineCustomEmbedRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'classic-software-timeline-embed-view',
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: [
			projectContextResource,

			resourceWithCondition(() => !fg('jira_software_timeline_perf_improvements'), fieldsResource),
		],

		entryPoint: () =>
			// eslint-disable-next-line jira/ff/no-preconditioning
			fg('jira_harmonised_software_timeline_embed') &&
			expVal('jira_timeline_harmonisation_m3', 'isEnabled', false)
				? classicSoftwareTimelineCustomEmbedPageEntrypoint
				: notFoundPageEntrypoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		supportsProjectTheme: 'full',
	}),
);
